import { appendProtocol } from '@/postContentElement/components/utils/link';
import { usePostContentContext } from '@/postContentElement/context';
import { evaluateAndAppendUTMParams } from '@/utils/evaluateAndAppendUTMParams';

interface Props {
  anchorId?: string;
  postUrl?: string;
  authorProfileImage?: string;
  authorName?: string;
  displayFollowerCount?: boolean;
  displayMetrics?: boolean;
  metricsDisplay?: string;
  description?: string;
  logoImageUrl?: string;
  followersDisplay?: string;
  thumbnailUrl?: string;
  reelsLogoImageUrl?: string;
}

const InstagramReel = ({
  anchorId,
  postUrl,
  authorName,
  displayFollowerCount,
  followersDisplay,
  thumbnailUrl,
  reelsLogoImageUrl,
}: Props) => {
  const { utmParams } = usePostContentContext();
  const postUrlWithUTMParams = evaluateAndAppendUTMParams(appendProtocol(postUrl), utmParams);

  return (
    <div id={anchorId} style={{ padding: '0.5rem 0.25rem' }}>
      <blockquote
        className="bh__ig_media mx-auto p-0 border border-[#d1d5db] bg-white hover:bg-[#f9fafb]"
        style={{
          maxWidth: '420px',
          minWidth: '326px',
          width: 'calc(100% - 2px)',
          borderRadius: '0.5rem',
        }}
      >
        <div>
          <a
            href={postUrlWithUTMParams}
            className="p-0 text-center w-full no-underline"
            target="_blank"
            rel="noreferrer"
          >
            <div className="flex items-center justify-between" style={{ padding: '0.75rem' }}>
              <div>
                <p className="text-[#1f2937] text-left font-bold" style={{ lineHeight: 1.5, fontSize: '0.875rem' }}>
                  {authorName}
                </p>
                {displayFollowerCount && (
                  <p className="text-[#6b7280] text-left" style={{ lineHeight: 1.5, fontSize: '0.875rem' }}>
                    {followersDisplay}
                  </p>
                )}
              </div>
              <div className="grow-0" style={{ marginRight: '0.75rem' }}>
                {reelsLogoImageUrl && (
                  <img src={reelsLogoImageUrl} alt="" className="w-[22px] h-[22px] border-0 block" />
                )}
              </div>
            </div>
            <div className="bh__ig_image_wrapper relative border-b border-t border-[#d1d5db]">
              <img alt="" src={thumbnailUrl} className="block max-w-full w-full h-auto border-0" />
            </div>
            <div style={{ padding: '0.75rem' }}>
              <p className="text-[#0095f6] text-center" style={{ lineHeight: 1.5 }}>
                <strong>View more on Instagram</strong>
              </p>
            </div>
          </a>
        </div>
      </blockquote>
    </div>
  );
};

export { InstagramReel };
